/* eslint-disable @typescript-eslint/no-var-requires */
export const getApiEndpoint = (): string => {
  if (typeof window === 'undefined') {
    return require('../utils/config').default.apiEndpoint
  } else {
    return window.apiEndpoint
  }
}
